import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import type { PageData, PortInfoType } from '../../../../types'
import { FormWrapper } from '../form-wrapper'
import { useFormHandlers } from '../../../../hooks/use-form-handlers'
import { TypeSelector } from './type-selector'
import { VesselAutocomplete } from './vessel-autocomplete'
import { InfoIcon } from '~components/icons'
import { COLORS } from '~theme/colors'
import { inputWidth } from '../../add-visit-flow'
import { pools } from '~types/vessel.types'

export function PageOne({
  formData = {},
  updateFormData,
  missingFields = [],
}: PageData) {
  const { handleVesselChange, onChangeHandler } = useFormHandlers(
    formData,
    updateFormData,
  )

  const handleTypeChange = (value: PortInfoType) => {
    updateFormData({ ...formData, type: value })
  }

  return (
    <FormWrapper>
      <Box>
        <TypeSelector
          value={formData.type}
          onChange={handleTypeChange}
          error={missingFields.includes('type')}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            mt: 1,
            color: COLORS.greys.ultraDark,
            width: inputWidth,
          }}
        >
          <Box sx={{ display: 'flex', flexShrink: 0, pt: '2px' }}>
            <InfoIcon size={16} aria-label="Information" />
          </Box>
          <Typography sx={{ fontSize: '0.875rem' }}>
            Select "Country" for information that applies to the country or a
            wider area, rather than a specific port/terminal/berth.
          </Typography>
        </Box>
      </Box>

      <VesselAutocomplete
        vesselName={formData?.vesselName}
        imoNumber={formData?.imoNumber}
        onVesselChange={handleVesselChange}
        error={
          missingFields.includes('vesselName') ||
          missingFields.includes('imoNumber')
        }
      />

      <FormControl size="small" sx={{ width: inputWidth }} required>
        <InputLabel id="pool-select-label">Pool/Segment</InputLabel>
        <Select
          labelId="pool-select-label"
          label="Pool/Segment"
          value={formData?.pool || ''}
          onChange={(e) =>
            onChangeHandler({ key: 'pool', value: e.target.value || undefined })
          }
          MenuProps={{ disablePortal: true }}
        >
          {pools.map((pool) => (
            <MenuItem key={pool.value} value={pool.value}>
              {pool.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </FormWrapper>
  )
}
